import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommunityBasic } from 'src/app/swagger-api';
import { CardType } from 'src/app/views/cards/cards.types';

import { SocialGroupService } from 'src/app/interfaces/social-groups.service';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { UserTableCreators } from 'src/app/views/table-users-list/adapters/table-creator.enum';
import { SearchCategories } from '../../search/search.enum';
import { SocialGroupInvolvementContext } from '../../shared/counters/social-groups-involvement-counters-context.abstract';
import { CommunitiesService } from '../communities.service';
import { UserTypes } from '../../profile/profile.enum';
import ProjectLinks from '../../../common/project.links';

@Component({
  selector: 'app-communities',
  templateUrl: './communities.component.html',
  styleUrls: ['./communities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommunitiesComponent extends SocialGroupInvolvementContext<CommunityBasic> {
  protected SEARCH_INPUT_LABEL = 'SEARCH_COMMUNITIES_FIELD_LABEL';
  // Success messages
  // - Confirm invite
  protected MANAGE_SOCIAL_GROUP_CONFIRM_INVITE_HINT = 'MANAGE_COMMUNITY_CONFIRM_INVITE_HINT';
  // - Reject invite
  protected MANAGE_SOCIAL_GROUP_REJECT_REQUEST_DIALOG_DESCRIPTION =
    'MANAGE_COMMUNITY_REJECT_REQUEST_DIALOG_DESCRIPTION';
  protected MANAGE_SOCIAL_GROUP_REJECT_REQUEST_DIALOG_TITLE = 'MANAGE_COMMUNITY_REJECT_REQUEST_DIALOG_TITLE';
  protected MANAGE_SOCIAL_GROUP_REJECT_REQUEST_DIALOG_BTN_HINT = 'MANAGE_COMMUNITY_REJECT_REQUEST_DIALOG_BTN_HINT';
  // - Delete invite
  protected MANAGE_SOCIAL_GROUP_REJECT_USER_REQUEST_HINT = 'MANAGE_COMMUNITY_REJECT_USER_REQUEST_HINT';

  private communitiesService = inject(CommunitiesService);

  public get route(): string {
    return this.sessionService.userType === UserTypes.ORGANIZATION
      ? ProjectLinks.LINK_CHARITY_CREATE
      : ProjectLinks.LINK_COMMUNITY_CREATE;
  }

  public get type(): CardType {
    return CardType.COMMUNITY;
  }

  protected getSocialGroupService(): SocialGroupService<CommunityBasic> {
    return this.communitiesService;
  }
  protected columnTypes(): ColumnTypes {
    return ColumnTypes.COMMUNITY;
  }

  protected searchCategories(): SearchCategories.COMMUNITIES {
    return SearchCategories.COMMUNITIES;
  }

  protected userRequestTableCreators(): UserTableCreators {
    return UserTableCreators.PERSONAL_USER_REQUESTS_FOR_COMMUNITY;
  }

  protected userInvitesTableCreators(): UserTableCreators {
    return UserTableCreators.PERSONAL_USER_INVITES_FOR_COMMUNITY;
  }
}
